/* eslint-disable react/no-did-update-set-state */
import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { RecaptchaVerifier, setPersistence, browserLocalPersistence, signInWithPhoneNumber } from 'firebase/auth';

import { firebaseAuth } from 'common/firebase';

import PhoneNumberForm from './PhoneNumberForm';
import PhoneCodeForm from './PhoneCodeForm';

import * as css from './PhoneLogin.scss';

const PHONE_FORM_STATE = {
	NONE: 'NONE',
	ENTER_PHONE: 'ENTER_PHONE',
	PHONE_SUBMITTED: 'PHONE_SUBMITTED',
	ENTER_CODE: 'ENTER_CODE',
	CODE_SUBMITTED: 'CODE_SUBMITTED',
};

const ERROR = {
	INVALID_PHONE_NUMBER: 'טלפון לא תקין',
	WRONG_PHONE_CODE: 'הקוד שגוי, אנא נסו שוב',
	TOO_MANY_REQUESTS: 'ניסיתם להתחבר מספר פעמים רב מדי בזמן קצר, אנא המתינו 10 דק לפני הניסיון הבא',
};

const TOO_MANY_REQUESTS = 'auth/too-many-requests';

export default class PhoneLogIn extends PureComponent {
	static propTypes = {
		className: PropTypes.string,
		withOnMainVideo: PropTypes.bool,
		checklistId: PropTypes.string.isRequired,
		user: PropTypes.shape({
			auth: PropTypes.shape({
				isLoggedIn: PropTypes.bool,
				error: PropTypes.string,
				isBusy: PropTypes.bool,
			}),
		}),
		// init: PropTypes.func.isRequired,
		login: PropTypes.func.isRequired,
		setError: PropTypes.func.isRequired,
		setBusy: PropTypes.func.isRequired,
		titleColor: PropTypes.string.isRequired,
		btnBgColor: PropTypes.string.isRequired,
		btnTextColor: PropTypes.string.isRequired,
	};

	static defaultProps = {
		className: '',
		withOnMainVideo: false,
		user: null,
	};

	static getDerivedStateFromProps(props, state) {
		if (props.user.auth.error !== state.error) {
			return {
				error: props.user.auth.error,
			};
		}
		return null;
	}

	constructor(props) {
		super(props);

		this.confirmationResult = null;
		this.phoneInputRef = createRef();

		this.state = {
			phoneFormState: PHONE_FORM_STATE.NONE,
			error: '',
		};
	}

	componentDidMount() {
		this.setupReCAPTCHA();
		// setTimeout(() => this.setState({ isShown: true }), 500);
	}

	componentDidUpdate(prevProps, prevState) {
		// if (!prevProps.admin.auth.isLoggedIn && this.props.admin.auth.isLoggedIn) {
		// }
		// if (!prevProps.user.auth.error && this.props.user.auth.error) {
		// 	this.setState({ error: this.props.user.auth.error });
		// }
	}

	setupReCAPTCHA = () => {
		window.recaptchaVerifier = new RecaptchaVerifier(
			'phoneSubmit',
			{
				size: 'invisible',
				callback: response => {
					// reCAPTCHA solved, allow signInWithPhoneNumber.
				},
			},
			firebaseAuth
		);
	};

	validatePhoneNumber = value => {
		const digits = `${value}`.replace(/\D/g, '');
		return digits.length === 12;
	};

	onPhoneInputFocus = () => {
		this.setState({ error: '' });
		this.props.setError('');
	};

	onPhoneFormSubmit = async phone => {
		const isNumberValid = this.validatePhoneNumber(phone);

		if (!isNumberValid) {
			this.props.setError(ERROR.INVALID_PHONE_NUMBER);
		} else {
			const appVerifier = window.recaptchaVerifier;
			try {
				this.props.setBusy(true);
				this.setState({ phoneFormState: PHONE_FORM_STATE.PHONE_SUBMITTED });
				this.confirmationResult = await setPersistence(firebaseAuth, browserLocalPersistence).then(() => {
					return signInWithPhoneNumber(firebaseAuth, phone, appVerifier);
				});
				this.setState({ phoneFormState: PHONE_FORM_STATE.ENTER_CODE });
				this.props.setBusy(false);
			} catch (err) {
				this.props.setBusy(false);
				if (err.code === TOO_MANY_REQUESTS) {
					this.props.setError(ERROR.TOO_MANY_REQUESTS);
				} else {
					this.props.setError(ERROR.INVALID_PHONE_NUMBER);
				}
				this.setState({ phoneFormState: PHONE_FORM_STATE.ENTER_PHONE });
			}
		}
	};

	onCodeFormSubmit = async code => {
		const { checklistId } = this.props;
		this.setState({ phoneFormState: PHONE_FORM_STATE.CODE_SUBMITTED });

		try {
			this.props.setBusy(true);

			const result = await this.confirmationResult.confirm(code);
			this.props.login({ type: 'phone', result, checklistId });
			this.props.setBusy(true);
		} catch (err) {
			this.props.setBusy(false);
			this.props.setError(ERROR.WRONG_PHONE_CODE);
			this.setState({ phoneFormState: PHONE_FORM_STATE.ENTER_CODE });
		}
	};

	renderPhoneForm = () => {
		const { phoneFormState } = this.state;
		const { user, btnBgColor, btnTextColor } = this.props;

		switch (phoneFormState) {
			case PHONE_FORM_STATE.ENTER_CODE:
			case PHONE_FORM_STATE.CODE_SUBMITTED:
				return (
					<PhoneCodeForm
						state={phoneFormState}
						onSubmit={this.onCodeFormSubmit}
						isBusy={user.auth.isBusy}
						authError={user.auth.error}
						onPhoneInputFocus={this.onPhoneInputFocus}
						btnBgColor={btnBgColor}
						btnTextColor={btnTextColor}
					/>
				);

			case PHONE_FORM_STATE.ENTER_PHONE:
			case PHONE_FORM_STATE.PHONE_SUBMITTED:
			default:
				return (
					<PhoneNumberForm
						state={phoneFormState}
						onSubmit={this.onPhoneFormSubmit}
						isBusy={user.auth.isBusy}
						authError={user.auth.error}
						onPhoneInputFocus={this.onPhoneInputFocus}
						btnBgColor={btnBgColor}
						btnTextColor={btnTextColor}
					/>
				);
		}
	};

	render() {
		const { className, withOnMainVideo, titleColor } = this.props;
		return (
			<div className={classNames(css.phoneLogin, withOnMainVideo && css.withOnMainVideo, className)}>
				<p className={css.title} style={{ color: titleColor }}>
					לפני שמתחילים בהצבעה, יש להתחבר באמצעות SMS
				</p>
				<div id="phoneSubmit"></div>
				{this.renderPhoneForm()}
				{this.props.user.auth.error && <p className={css.error}>{this.props.user.auth.error}</p>}
			</div>
		);
	}
}
